import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../../app/api/rp_api";
import {FloorPreviewUrl} from "./fetch_building_planner_details";

interface Building {
    uuid: string;
    name: string;
    floor_preview_urls: FloorPreviewUrl[];
}

interface PlannerInvestmentData {
    uuid: string;
    name: string;
    is_ready: boolean;
    last_plan_update: string;
    floor_preview_urls: Building[];
}

const readClientApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getPlannerInvestmentData: build.query<PlannerInvestmentData, {investmentUuid: string}>({
            query: ({investmentUuid}) => ({
                url: apiLink.planner.investments.detail({})({investmentUuid})
            })
        })
    })
});

export const {useGetPlannerInvestmentDataQuery} = readClientApi;
import {apiLink} from "@pg-mono/rp-api-routes";

import {rpApi} from "../../../../app/api/rp_api";
import {FloorPreviewUrl} from "./fetch_building_planner_details";

interface Building {
    uuid: string;
    name: string;
    floor_preview_urls: FloorPreviewUrl[];
}

interface PlannerInvestmentData {
    uuid: string;
    name: string;
    is_ready: boolean;
    last_plan_update: string;
    floor_preview_urls: Building[];
}

const readClientApi = rpApi.injectEndpoints({
    endpoints: (build) => ({
        getPlannerInvestmentData: build.query<PlannerInvestmentData, {investmentUuid: string}>({
            query: ({investmentUuid}) => ({
                url: apiLink.planner.investments.detail({})({investmentUuid})
            })
        })
    })
});

export const {useGetPlannerInvestmentDataQuery} = readClientApi;
